export const PlacePersonnelRole = {
    PLACE_PERSONNEL: "پرسنل مرکز",
        PLACE_OWNER: "مدیر مرکز",
        PLACE_COACH: "مربی",
}
